import cn from '@smallwei/avue/lib/locale/lang/zh';
import en from '@smallwei/avue/lib/locale/lang/en';
import ph from './ph';
export default {
  'zh-cn': cn,
  en,
  ph
};
